import { Route, Switch } from "wouter";
import { CasaviContactBlacklistView } from "./casavi-contact-blacklist.view";
import { CasaviContactBlacklistCreateView } from "./create/create.view";
import { CasaviContactBlacklistUpdateView } from "./update/update.view";

export function CasaviContactBlacklistRoutes() {
  return (
    <Switch>
      <Route path="/" component={CasaviContactBlacklistView} />
      <Route path="/create" component={CasaviContactBlacklistCreateView} />
      <Route path="/:uuid/update" component={CasaviContactBlacklistUpdateView} />
    </Switch>
  );
}
